/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.onboarding.di

import org.koin.core.module.Module
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import studio.oddpods.cauce.feature.onboarding.painid.PainIdViewModel
import studio.oddpods.cauce.feature.onboarding.profile.ProfileSetupViewModel

val OnboardingModule: Module = module {
    viewModel {
        PainIdViewModel(
            profileRepository = get(),
            analyticsHelper = get(),
        )
    }
    viewModelOf(::ProfileSetupViewModel)
}
